import { IAnimal } from '../DexieDB/modules/animals/entities/IAnimal';

export function isAnimal(data: any): data is IAnimal {
  if (!data) {
    return false;
  }
  return 'ra_a' in data;
}
